import { getPricingPlans, upgradePricingPlan } from "./pricing-plan.service";

export const pricingPlanService = { getPricingPlans, upgradePricingPlan };
